export default __webpack_public_path__ + "static/media/002.c848a9cd.jpg";